 import React, { useState, useEffect } from 'react';
import {Link} from "react-router-dom";
  import styles from "./component.module.scss"
  import axios from 'axios';

  function RegisterPokerTour() {
    const [registerList, setRegisterList] = useState<any | null>(null);
    const limit = 160;

    useEffect(() => {
      axios.get('https://labuzifpokerclub.fr/back/api/list_register.php?type=pokertour')
        .then((response) => {
          setRegisterList(response.data.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }, []);

    const players: any[] = registerList ?? [];
    const registered = players.slice(0, limit);
    const waitingList = players.slice(limit);

    const renderTable = (list: any[], offset: number) => (
        <table className={styles.tableRegister}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Prénom</th>
                    <th>Pseudo</th>
                    <th>Club</th>
                </tr>
            </thead>
            <tbody>
                {list.map((item: any, index: number) => (
                    <tr key={offset + index}>
                        <td>{offset + index + 1}</td>
                        <td>{item.pt_firstname}</td>
                        <td>{item.pt_pseudo}</td>
                        <td>{item.pt_club}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    return (
        <div>
            <button><Link to="/">Retour</Link></button>
            <h1>Inscription Poker Tour ({registered.length} joueurs inscrits)</h1>
            {renderTable(registered, 0)}
            {waitingList.length > 0 && (
                <>
                    <h2>Liste d'attente ({waitingList.length} joueurs)</h2>
                    {renderTable(waitingList, limit)}
                </>
            )}
        </div>
    )
}   
export default RegisterPokerTour;